import { CurrencyCode, Navigation, Product } from '@noths/polaris-dev-ts-types';
import { SerializedError } from '@reduxjs/toolkit';

import { Category, Filter, Partner, SortOption } from 'src/types';

export enum TriggerName {
  LOAD_MORE_PRODUCTS = 'loadMoreProducts',
  LOAD_PREVIOUS_PRODUCTS = 'loadPreviousProducts',
}

export interface RequestProductsActionPayloadData {
  currencyCode: CurrencyCode;
  category: Category | null;
  filters: Filter[];
  currentPage: number;
  totalPages: number;
  totalProducts: number;
  productsReturnedCount: number;
  perPage: number;
  queryType: string;
  sortingOptions: SortOption[];
  navigation: Navigation[];
  partner?: Partner;
  errorCode?: string;
  errorMessage?: string;
  searchTerm?: string;
  providerAttributionToken: string | null;
  items: Record<number, Product[]>;
  zeroExactResults?: boolean;
  pinnedResultCount?: number;
}

export interface RequestProductsActionPayload {
  data?: RequestProductsActionPayloadData;
  triggerName?: TriggerName;
  redirectUrl?: string;
}

export interface ProductsState {
  currencyCode: CurrencyCode;
  deliveryZone?: string;
  searchTerm: string;
  items: Record<number, Product[]>;
  currentPage: number;
  pageLoading: number | null;
  totalPages: number;
  totalProducts: number;
  lastRequestedPageNumber: number;
  productsReturnedCount: number;
  queryType: string;
  isLoading: boolean;
  isUpdateFiltersLoading: boolean;
  category: Category | null;
  navigation: Navigation[];
  partner?: Partner;
  error?: SerializedError | null;
  redirectUrl?: string;
  featuredProduct: Product | null;
  providerAttributionToken: string | null;
  zeroExactResults?: boolean | null;
  pinnedResultCount?: number | null;
  showFewResultsMessage?: boolean;
  initalProductPage?: number;
}
